import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export type BreadcrumbsProps = {
    breadcrumbs: Breadcrumb[];
    className?: string;
};
export type Breadcrumb = { label: string; path?: string };

const Breadcrumbs = ({ breadcrumbs, className }: BreadcrumbsProps) => {
    return (
        <nav className={classNames('flex items-center gap-2 h-9 text-sm', className)} role='navigation'>
            {breadcrumbs.map((item, index) => {
                const isLast = index === breadcrumbs.length - 1;
                return (
                    <React.Fragment key={index}>
                        <span data-testid='breadcrumb'>
                            {item.path ? (
                                <Link
                                    className='text-muted-foreground hover:text-foreground hover:underline'
                                    to={item.path}
                                    data-testid='breadcrumb-link'
                                >
                                    {item.label}
                                </Link>
                            ) : (
                                <span className='text-foreground font-medium'>{item.label}</span>
                            )}
                        </span>
                        {!isLast && <ChevronRight className='text-muted-foreground' size={16} data-testid='breadcrumb-separator' />}
                    </React.Fragment>
                );
            })}
        </nav>
    );
};

export default Breadcrumbs;
